// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    getEstimateTotals as getEstimateTotalsService,
    GetEstimateTotalsApiParameter,
    GetEstimateTotalsModel,
} from "@guestsupply/App/Services/AutoDelivery";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import translate from "@insite/client-framework/Translate";

type HandlerType = ApiHandler<
    GetEstimateTotalsApiParameter & HasOnSuccess & HasOnError<string>,
    ServiceResult<GetEstimateTotalsModel> & {
        errorMessage?: string;
    }
>;

export const GetEstimateTotalsFromApi: HandlerType = async props => {
    const estimateTotals = await getEstimateTotalsService({
        productId: props.parameter.productId,
        qty: props.parameter.qty,
        shipViaId: props.parameter.shipViaId,
        uom: props.parameter.uom,
    });
    if (estimateTotals.successful) {
        props.dispatch({
            type: "xAutoDelivery/CompleteSetestimateTotalsData",
            estimateTotalsData: estimateTotals?.result,
        } as any);
    } else {
        props.apiResult = {
            ...props.apiResult,
            errorMessage: estimateTotals?.errorMessage || translate("An error has occurred"),
        };
    }

    props.apiResult = estimateTotals;
};
export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.();
    }
};
export const ExecuteOnErrorCallback: HandlerType = props => {
    if (props.apiResult?.errorMessage) {
        props.parameter.onError?.(props.apiResult?.errorMessage as any);
    }
};
export const chain = [GetEstimateTotalsFromApi, ExecuteOnSuccessCallback, ExecuteOnErrorCallback];

const getEstimateTotals = createHandlerChainRunner(chain, "getEstimateTotals");
export default getEstimateTotals;
